<script>
export default {
  name: 'InfoIcon'
}
</script>

<template>
  <span class="material-symbols-outlined info-icon">info_i</span>
</template>

<style scoped lang="scss">
.info-icon {
  margin-left: -3px;
  font-size: 15px;
  color: $iconColorAccent;
  vertical-align: -3px;
  cursor: default;
}
</style>
